import { startCase } from 'lodash'

/** `Location.pms` is free text ("open dental"); these are the vendors' own spellings. */
const PMS_DISPLAY_NAMES: Record<string, string> = {
  'open dental': `Open Dental`,
  opendental: `Open Dental`,
  dentrix: `Dentrix`,
  'dentrix ascend': `Dentrix Ascend`,
  ascend: `Dentrix Ascend`,
  eaglesoft: `Eaglesoft`,
  carestack: `CareStack`,
  sikka: `Sikka`,
}

export function pmsDisplayName(pms: string | null | undefined, fallback: string): string {
  if (!pms) return fallback
  return PMS_DISPLAY_NAMES[pms.trim().toLowerCase()] ?? startCase(pms)
}
